import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  activeList,
  gradeOne,
  gradePercentage,
  gradePoints,
  marksFrom,
  marksUpto,
  statusOption,
} from "../../../../core/common/selectoption/selectoption";
import Table from "../../../../core/common/dataTable/index";
import { gradetable } from "../../../../core/data/json/grade";
import { TableData } from "../../../../core/data/interface";
import CommonSelect from "../../../../core/common/commonSelect";
import PredefinedDateRanges from "../../../../core/common/datePicker";
import { all_routes } from "../../../router/all_routes";
import TooltipOption from "../../../../core/common/tooltipOption";
import { _get, _post } from "../../../Utils/Helper";
import { Button, Input } from "antd";
import { toast } from "react-toastify";
const _form ={
  min_score:"",
  max_score:"",
  grade:"",
  remark:"",
  status:"Active",
}
const Grade = () => {
  const routes = all_routes;
  const data = gradetable;
  const [grades, setGrades] = useState([])
  const [form, setForm] = useState(_form);

  const handleChanges = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const getGrades = useCallback(()=>{
    _get(
      "grade-setup?query_type=select-all",
      (res) => {
        console.log(res);
        if (res.data && res.data.length) {
          setGrades(res.data);
        }
      },
      (err) => {
        toast.error("Error occured")
        console.error("Error: ",err);
      }
    );
  },[])

  useEffect(() => {
   getGrades()
  }, [])
  const handleSubmit = ()=>{
    _post('grade-setup', form, 
      (res)=>{
        if(res.success){
          getGrades()
          toast.success('Submitted');
          setForm(_form);
        }
      console.log(res);
    }, (err)=>{
      toast.error("Error: Not Submitted.");
      console.log(err);
    })
  }
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      handleSubmit()
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const columns = [
    // {
    //   title: "#",
    //   dataIndex: "id",
    //   render: (text: string, record:any, index: number) => (
    //     <>
    //       <Link to="#" className="link-primary">
    //         {index+1}
    //       </Link>
    //     </>
    //   ),
    //   sorter: (a: TableData, b: TableData) => a.id.length - b.id.length,
    // },
    {
      title: "Grade",
      dataIndex: "grade",
      render: (text: string) => (
        <>
          <span className="">
            {text}
          </span>
        </>
      )
    },
    
    {
      title: "Min Score",
      dataIndex: "min_score",
      render: (text: string) => (
        <>
          <span className="">
            {text}%
          </span>
        </>
      )
    },
    {
      title: "Max Score",
      dataIndex: "max_score",
      render: (text: string)=> (
        <>
         <span className="">
            {text}%
          </span>
        </>
      ),
    },
    {
      title: "Remark",
      render: (record: any) => (
        <>
          <span className="">
            {record.remark}
          </span>
        </>
      )
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (dataIndex:number, record: any, x:any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Button
                    className="dropdown-item rounded-1"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_grade"
                    onClick={()=>setForm({...record, query_type:'UPDATE'})}
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Button>
                </li>
                <li>
                  <Button
                    className="dropdown-item rounded-1"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                    onClick={()=>{
                      setForm({...record, id:record.id, query_type:'DELETE'})
                    
                    }}
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Button>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              {/* <h3 className="page-title mb-1">Grade</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Academic </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Grade
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#add_grade"
                >
                  <i className="ti ti-square-rounded-plus-filled me-2" />
                  Add Grade
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div className="card">
            {/* {JSON.stringify(form)} */}
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Grade List</h4>
              <div className="d-flex align-items-center flex-wrap">
               
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Guardians List */}
              <Table columns={columns} dataSource={grades} Selection={false} />

              {/* /Guardians List */}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <>
        <div className="d-flex align-items-center">
          <div className="dropdown">
            <Link
              to="#"
              className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="ti ti-dots-vertical fs-14" />
            </Link>
            <ul className="dropdown-menu dropdown-menu-right p-3">
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#edit_grade"
                >
                  <i className="ti ti-edit-circle me-2" />
                  Edit 1
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#delete-modal"
                >
                  <i className="ti ti-trash-x me-2" />
                  Delete 1
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* Add Grade */}
        <div className="modal fade" id="add_grade">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Grade</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Grade</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Marks From(%)</label>
                        <Input type='number' className="select" name="min_score" onChange={handleChanges} />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Marks Upto(%)</label>
                        <Input type='number' className="select" name="max_score" onChange={handleChanges} />
                        </div>
                      <div className="mb-3">
                        <label className="form-label">Grade</label>
                        <CommonSelect
                          className="select"
                           placeholder="Select Grade"
                          defaultValue={{
                            value:form.grade,
                            label:form.grade
                          }}
                          handleChange={(e:any) =>
                            setForm((prev) => ({
                              ...prev,
                              grade: e.value,
                            }))
                          }
                          options={gradePoints}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Status</label>
                        <CommonSelect 

                        defaultValue={{label:form.status, value:form.status}}
                        handleChange={(e:any)=>{
                          setForm((x)=>({...x, status:e.value}))
                        }}
                        className="select" options={activeList} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                  >
                    Add Grade
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Add Grade */}
        {/* Edit Grade */}
        <div className="modal fade" id="edit_grade">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Grade</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Grade</label>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Enter Grade"
                          name="grade"
                          onChange={handleChanges}
                          value={form.grade}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Min Score(%)</label>
                        <Input
                          className="text"
                          placeholder="Enter Min Score"
                          onChange={handleChanges}
                          name="min_score"
                          value={form.min_score}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Max Score(%)</label>
                        <Input
                          className="text"
                          name="max_score"
                          value={form.max_score}
                          placeholder="Enter Max Score"
                          onChange={handleChanges}
                        />
                      </div>
                      
                      <div className="mb-3">
                        <label className="form-label">Remark</label>
                        <Input
                          className="text"
                          name="remark"
                          value={form.remark}
                          placeholder="Enter Remark"
                          onChange={handleChanges}
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Status</label>
                        <CommonSelect
                        className="select"
                          placeholder="Select Status"
                          options={activeList}
                          defaultValue={{label:form.status, value:form.status}}
                          handleChange={(e:any)=>{
                            setForm((x)=>({...x, status:e.value}))
                          }}
                        />
                      </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                  >
                    Save Changes
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Edit Grade */}
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Button
                      onClick={()=>handleSubmit()}
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default Grade;
